export const ADMIN_REQUEST_PENDING = "ADMIN_LOGIN_REQUEST_PENDING";
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGOUT_SUCCESS = "ADMIN_LOGOUT_SUCCESS"
export const ADMIN_FAILURE = "ADMIN_LOGIN_FAILURE";